import { Inject,Injectable,InjectionToken } from '@angular/core';
import {
AuthenticationService,
AuthenticationServiceToken,
} from './auth.service';
import { ILogService,IRoleService } from './i';
import { LogServiceToken } from './log.service';

// Originally from http://jasonwatmore.com/post/2016/08/16/angular-2-jwt-authentication-example-tutorial

@Injectable()
export class RoleService implements IRoleService {
  constructor(
    @Inject(AuthenticationServiceToken)
    private authService: AuthenticationService,
    @Inject(LogServiceToken) private log: ILogService
  ) {}
  public canActivate(
    routeFrag: string,
    params: { [key: string]: string }
  ): boolean {
    const routeFragTemp = routeFrag[0] === '/' ? routeFrag.substr(1) : routeFrag;
    switch (routeFragTemp) {
      case 'correspondences':
      case 'correspondences/:filter':
      case 'correspondence':
      case 'correspondence/:id':
      case 'download/:id':
        return (
          this.authService.isAuthenticated &&
          this.authService.hasAnyRole('Admin', 'Shepherd', 'Reviewer', 'Intake')
        );
      case 'correspondence/:id/reviews/add':
      case 'correspondence/:cid/reviews/:rid':
      case 'correspondence/:cid/reviews/:rid/documents/add':
        return (
          this.authService.isAuthenticated &&
          this.authService.hasAnyRole('Admin', 'Shepherd', 'Reviewer')
        );
      case 'correspondence/add':
      case 'correspondence/:id/documents/add':
        return (
          this.authService.isAuthenticated &&
          this.authService.hasAnyRole('Admin', 'Shepherd', 'Intake')
        );
      case 'contacts':
      case 'contacts/:id':
      case 'contacts/:id/details/:id':
        return (
          this.authService.isAuthenticated &&
          this.authService.hasAnyRole('Admin', 'Shepherd', 'Intake')
        );
      case 'users':
      case 'users/add':
      case 'users/:id':
      case 'choose/user':
        return (
          this.authService.isAuthenticated &&
          this.authService.hasAnyRole('Admin', 'Shepherd')
        );
      case 'settings':
        return (
          this.authService.isAuthenticated && this.authService.hasAnyRole()
        );
      default:
        this.log.warn(
          `Neither ${routeFrag} nor ${routeFragTemp} is not a known route. Authorization denied by default.`
        );
    }

    return false;
  }
}

export const RoleServiceToken = new InjectionToken('IRoleServiceToken');
